module.exports = __webpack_public_path__ + "img/villavela.f7a67055.svg";